// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const ANT_LING_MODELS = {
	"Ling-2.6-1T": {
		id: "Ling-2.6-1T",
		name: "Ling 2.6 1T",
		api: "openai-completions",
		provider: "ant-ling",
		baseUrl: "https://api.ant-ling.com/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"ant-ling","supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.25,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Ling-2.6-flash": {
		id: "Ling-2.6-flash",
		name: "Ling 2.6 Flash",
		api: "openai-completions",
		provider: "ant-ling",
		baseUrl: "https://api.ant-ling.com/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"ant-ling","supportsLongCacheRetention":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.01,
			output: 0.02,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Ring-2.6-1T": {
		id: "Ring-2.6-1T",
		name: "Ring 2.6 1T",
		api: "openai-completions",
		provider: "ant-ling",
		baseUrl: "https://api.ant-ling.com/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","thinkingFormat":"ant-ling","supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":null,"medium":null,"high":"high","xhigh":"xhigh"},
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.25,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
} as const;
